var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPages)?_c('div',{staticClass:"pagination section"},[_c('b-button',{class:[
      'pagination__control',
      { 'pagination__control--disabled': !_vm.hasPrev }
    ],attrs:{"icon-left":"chevron-left","type":"is-info"},on:{"click":function($event){return _vm.getPage('prev')}}}),_c('span',{staticClass:"pagination__label"},[_vm._v(" Page "+_vm._s(_vm.currentPage)+" ")]),_c('b-button',{class:[
      'pagination__control',
      { 'pagination__control--disabled': !_vm.hasNext }
    ],attrs:{"icon-right":"chevron-right","type":"is-info"},on:{"click":function($event){return _vm.getPage('next')}}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }